import { FC } from 'react';

import { DayPicker } from 'react-day-picker';
import { twMerge } from 'tailwind-merge';

import { MAX_DATE, MIN_DATE } from '../../../lib';
import { ModalTemplate } from '../../templates';
import { TDayPickerSingleProps } from './types';

export const SelectDateModal: FC<TDayPickerSingleProps> = ({
  title = 'Select a date',
  className,
  selected,
  ...props
}) => {
  return (
    <ModalTemplate
      id="Select Date Modal"
      isHasCloseBtn
      title={title}
      className="px-0"
    >
      <DayPicker
        selected={selected}
        captionLayout="dropdown"
        defaultMonth={selected}
        fromDate={MIN_DATE}
        toDate={MAX_DATE}
        numberOfMonths={12}
        pagedNavigation={false}
        disableNavigation
        className={twMerge('w-full', className)}
        weekStartsOn={1}
        mode="single"
        classNames={{
          months: 'flex flex-col gap-3 px-4',
          caption_label: 'heading-xs px-2 py-4',
          day: 'typography-16r mx-auto flex items-center justify-center w-11 h-full',
          table: 'w-full border-collapse',
          cell: 'w-11 h-11',
          head_cell: 'text-base-100 text-[15px] font-normal leading-[18px]',
          day_selected:
            'bg-brand-500 rounded-full transition-colors duration-200 hover:hover-bg-brand-500-hover',
          vhidden: 'hidden',
          row: 'px-[2px]',
        }}
        {...props}
      />
    </ModalTemplate>
  );
};
